<template>
  <div class="year-range-picker">
    <el-date-picker v-model="dateList[0]" type="year" placeholder="选择开始年" class="year-picker" :format="format"
      :value-format="valueFormat" :picker-options="startDatePicker" :clearable="clearable" :editable="editable">
    </el-date-picker>
    <span class="range-word"> 至 </span>
    <el-date-picker v-model="dateList[1]" type="year" placeholder="选择结束年" class="year-picker" :format="format"
      :value-format="valueFormat" :picker-options="endDatePicker" :clearable="clearable" :editable="editable"
      prefix-icon="none">
    </el-date-picker>
  </div>
</template>

<script>
  export default {
    name: "YearPicker",
    // 接收父组件传入的数据
    props: {
      value: {
        // type: Array,
        required: true,
      },
      clearable: {
        type: Boolean,
        default: false,
      },
      editable: {
        type: Boolean,
        default: false,
      },
      format: {
        type: String,
        default: 'yyyy'
      },
      valueFormat: {
        type: String,
        default: 'yyyy'
      },
    },
    data() {
      return {
        dateList: [],
        startDatePicker: this.beginDate(),
        endDatePicker: this.processDate(),
      };
    },
    watch: {
      value(v) {
        this.dateList = v || []
      },
      dateList(v) {
        this.$emit('input', v)
      }
    },
    mounted() {
      this.dateList = this.value || []
    },
    methods: {
      // 选择年份范围选择时开始时间不能大于结束时间，结束时间不能小于开始时间

      // 提出开始时间必须小于提出结束时间
      beginDate() {
        let self = this
        return {
          disabledDate(time) {
            if (self.dateList[1] !== null && self.dateList[1] !== '') {
              let fixedTime = new Date(time)
              return fixedTime.getFullYear() > self.dateList[1]
            }
            return false
          }
        }
      },
      // 提出结束时间必须大于提出开始时间
      processDate() {
        let self = this
        return {
          disabledDate(time) {
            // let fixedTime = new Date(self.oldTime).getTime()
            // return time.getTime() < fixedTime
            let fixedTime = new Date(time)
            return fixedTime.getFullYear() < self.dateList[0]
          }
        }
      },

    },
  };
</script>


<style scoped>
  .year-range-picker {
    color: black;
    text-align: center;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    overflow: hidden;
    display: flex;
  }

  >>>.el-input__inner {
    border: 0;
    text-align: center;
  }

  .range-word {
    font-size: 13px;
    color: #303133;
  }

  .year-range-picker .year-picker {
    max-width: 140px;
    margin: 0;
  }
</style>
